import DiscussionListItem from './DiscussionListItem';
import Link from '../../common/components/Link';
import app from '../app';
import highlight from '../../common/helpers/highlight';
import listItems from '../../common/helpers/listItems';
import classList from '../../common/utils/classList';
import humanTime from '../../common/utils/humanTime';
export default class MinimalDiscussionListItem extends DiscussionListItem {
  elementAttrs() {
    const attrs = super.elementAttrs();
    attrs.className = classList(attrs.className, 'MinimalDiscussionListItem');
    return attrs;
  }
  viewItems() {
    return super.viewItems().remove('controls').remove('slidableUnderneath');
  }
  contentItems() {
    return super.contentItems().remove('stats');
  }
  authorItems() {
    return super.authorItems().remove('badges');
  }
  authorTooltipText(user) {
    const post = this.attrs.post;
    if (!post) {
      return super.authorTooltipText(user);
    }
    return app.translator.trans('core.forum.discussion_list.replied_text', {
      user,
      ago: humanTime(post.createdAt())
    });
  }
  mainView() {
    const discussion = this.attrs.discussion;
    const jumpTo = this.getJumpTo();
    return m(Link, {
      href: app.route.discussion(discussion, jumpTo),
      className: "DiscussionListItem-main"
    }, m("h2", {
      className: "DiscussionListItem-title"
    }, this.badgesView(), m("div", null, highlight(discussion.title(), this.highlightRegExp))), m("ul", {
      className: "DiscussionListItem-info"
    }, listItems(this.infoItems().toArray())));
  }
}
flarum.reg.add('core', 'forum/components/MinimalDiscussionListItem', MinimalDiscussionListItem);